import request from '@/utils/request'

// 所有客户列表
export function getAllCustomerList(data) {
  return request({
    url: '/api/customer/list/all',
    method: 'POST',
    data
  })
}
// 业主客户列表
export function getHouseholderList(data) {
  return request({
    url: '/api/customer/list',
    method: 'POST',
    data
  })
}
// 新增业主
export function createHouseholder(data) {
  return request({
    url: '/api/customer/create/owner',
    method: 'PUT',
    data
  })
}
// 修改业主客户
export function updateHouseholder(data) {
  return request({
    url: '/api/customer/update',
    method: 'PUT',
    data
  })
}
// 删除客户（业主客户/临时客户）
export function delHouseholder(id) {
  return request({
    url: `/api/customer/delete/${id}`,
    method: 'delete'
  })
}

// 客户详情（业主客户/临时客户）
export function getHouseholder(customerId) {
  return request({
    url: `/api/customer/detail/${customerId}`
  })
}

